import { inject, Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'

@Injectable()
export class MasterdataTitleStrategy extends TitleStrategy {
  private readonly appName = 'Masterdata'
  private readonly title = inject(Title)

  constructor() {
    super()
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const sectionTitle = this.buildTitle(routerState)
    const pageTitle = sectionTitle ? `${sectionTitle} - ${this.appName}` : this.appName
    this.title.setTitle(pageTitle)
  }
}
